import Pusher from 'pusher-js';

function getAuthEndpoint(rootState) {
  // webApiRoot ends with '/w' and pusherAuthEndpoint starts with a '/w' so we need to remove one.
  return `${rootState.system.webApiRoot.replace(/\/w$/, '')}${rootState.system.pusherAuthEndpoint}`;
}

function connectPusher(rootState, force = false) {
  const pusherApiKey = rootState.system.pusherApiKey;

  if ((force || !window.pusher) && pusherApiKey) {
    if (window.pusher) {
      window.pusher.disconnect();
    }

    const authEndpoint = getAuthEndpoint(rootState);

    if (process.env.NODE_ENV === 'development') {
      Pusher.logToConsole = false;
    }

    const token = localStorage.getItem('pbdToken');
    const devMode = {};
    if (process.env.NODE_ENV === 'development') {
      const devHeader = process.env.VUE_APP_DEV_HEADER.split(':');
      devMode[devHeader[0]] = devHeader[1];
    }

    window.pusher = new Pusher(pusherApiKey, {
      cluster: 'eu',
      auth: {
        headers: {
          Authorization: `Bearer ${token}`,
          ...devMode,
        },
      },
      authEndpoint,
    });

    // window.pusher.bind_global((e) => {
    //   console.log('event global', e);
    // });
  }
}

function channelIsConnected(channelName) {
  let channelExists = false;
  const channelKeys = window.pusher.channels && window.pusher.channels.channels ? Object.keys(window.pusher.channels.channels) : [];
  if (channelKeys.includes(channelName)) {
    channelExists = true;
  }

  return channelExists;
}

export { connectPusher, channelIsConnected };
